import { Trans } from '@lingui/react'
import { IconCheck } from '@redteclab/icons'
import classNames from 'clsx'

import {
  TENANT_BE,
  TENANT_CH,
  TENANT_IT,
  TYPE_ADD_TO_CART_BOTTOM,
  TYPE_ADD_TO_CART_CENTER,
  TYPE_ADD_TO_CART_TOP,
} from 'shared/consts'
import {
  CARTINTERMEDIATE_COMBINED_CSWS_EXPERIMENT,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { useGetExperimentPerTenant } from 'shared/experiments/utils/tenantBasedExperimentsUtils'
import ButtonWithIcons from 'views/components/molecules/ButtonWithIcons'
import Tenant from 'views/components/utils/Tenant'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

const CswFilters = ({ wid }: { wid: number }) => {
  const {
    crosssell: { widgets },
  } = usePublicConfig()
  const experiment = useGetExperimentPerTenant(
    CARTINTERMEDIATE_COMBINED_CSWS_EXPERIMENT
  )

  const whiteListedWidgetIds = [
    widgets[TYPE_ADD_TO_CART_BOTTOM],
    widgets[TYPE_ADD_TO_CART_CENTER],
    widgets[TYPE_ADD_TO_CART_TOP],
  ]

  if (
    !whiteListedWidgetIds.includes(wid) ||
    !experiment.isEnabled ||
    experiment.variant !== EXPERIMENT_VARIATION.V1
  ) {
    return null
  }

  return (
    <div className="l-flex l-flex--distribute-space@medium u-overflow-x--auto@small-tiny">
      <ButtonWithIcons
        style="buttonPrimary"
        name="cartIntermediateTop"
        icon={
          widgets[TYPE_ADD_TO_CART_TOP] === wid ? (
            <IconCheck className="u-vertical-align--with-stars" />
          ) : null
        }
        className={classNames('e-CswFilters', {
          'e-CswFilters-active': widgets[TYPE_ADD_TO_CART_TOP] === wid,
        })}
      >
        <Trans id="productSliders.cartIntermediateTop.headline" />
      </ButtonWithIcons>
      <ButtonWithIcons
        style="buttonPrimary"
        name="cartIntermediateMiddle"
        icon={
          widgets[TYPE_ADD_TO_CART_CENTER] === wid ? (
            <IconCheck className="u-vertical-align--with-stars" />
          ) : null
        }
        className={classNames('e-CswFilters', {
          'e-CswFilters-active': widgets[TYPE_ADD_TO_CART_CENTER] === wid,
        })}
      >
        <Trans id="productSliders.cartIntermediateMiddle.headline" />
      </ButtonWithIcons>

      <Tenant not tenant={[TENANT_CH, TENANT_IT, TENANT_BE]}>
        <ButtonWithIcons
          style="buttonPrimary"
          name="cartIntermediateBottom"
          icon={
            widgets[TYPE_ADD_TO_CART_BOTTOM] === wid ? (
              <IconCheck className="u-vertical-align--with-stars" />
            ) : null
          }
          className={classNames('e-CswFilters', {
            'e-CswFilters-active': widgets[TYPE_ADD_TO_CART_BOTTOM] === wid,
          })}
        >
          <Trans id="productSliders.cartIntermediateBottom.headline" />
        </ButtonWithIcons>
      </Tenant>
    </div>
  )
}

export default CswFilters
